import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedJobsPanel = ({ savedJobs, onViewSaved, onClearSaved }) => {
  if (savedJobs?.length === 0) {
    return null;
  }

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="Bookmark" size={20} color="var(--color-accent)" />
          <h3 className="font-heading font-semibold text-base text-foreground">
            Opgeslagen opdrachten
          </h3>
          <span className="caption bg-accent text-accent-foreground px-2 py-0.5 rounded-full">
            {savedJobs?.length}
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSaved}
          iconName="X"
          iconPosition="left"
        >
          Wissen
        </Button>
      </div>
      <div className="space-y-2 mb-3">
        {savedJobs?.slice(0, 3)?.map((job) => (
          <div
            key={job?.id}
            className="flex items-center justify-between p-2.5 bg-card rounded-lg"
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate mb-0.5">
                {job?.title}
              </p>
              <p className="caption text-muted-foreground truncate">
                {job?.clientCompany} • €{job?.hourlyRate?.toFixed(2)}/uur
              </p>
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 ml-2" />
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onViewSaved}
        iconName="Eye"
        iconPosition="left"
        fullWidth
      >
        Bekijk alle opgeslagen
      </Button>
    </div>
  );
};

export default SavedJobsPanel;